import TrainLineMap from '~/components/TrainLineMap';
import { CityPlannerInterface } from '~/payload-types';

type Props = CityPlannerInterface & {};

export const CityPlannerBlock = (props: Props) => {
  // Coordinates for Austrian cities
  const points = [
    { name: 'Salzburg Hbf', lat: 47.813056, lng: 13.045833 },
    { lat: 47.827389557236856, lng: 13.055362701416017 },
    { lat: 47.83424634105553, lng: 13.066606521606447 },
    { lat: 47.84000764374806, lng: 13.064632415771486 },
    { lat: 47.84565309972307, lng: 13.057250976562502 },
    { lat: 47.849857989078785, lng: 13.057250976562502 },
    { lat: 47.85308342656376, lng: 13.063087463378908 },
    { lat: 47.8529394380969, lng: 13.07252883911133 },
    { lat: 47.856740599573854, lng: 13.079566955566406 },
    { lat: 47.8578636166839, lng: 13.091583251953127 },
    { lat: 47.865608892724715, lng: 13.09793472290039 },
    { lat: 47.866731717739135, lng: 13.10892105102539 },
    { lat: 47.871568224354306, lng: 13.113512992858888 },
    { lat: 47.875080166507544, lng: 13.11849117279053 },
    { lat: 47.88285165125086, lng: 13.118362426757814 },
    { lat: 47.893528345567425, lng: 13.120636940002443 },
    { lat: 47.8965496519077, lng: 13.12346935272217 },
    { lat: 47.902246492784094, lng: 13.136129379272463 },
    { lat: 47.90664816774978, lng: 13.14145088195801 },
    { lat: 47.91093440649924, lng: 13.143210411071777 },
    { lat: 47.91435738919417, lng: 13.149819374084474 },
    { lat: 47.91634204016118, lng: 13.157501220703127 },
    { lat: 47.92341713281856, lng: 13.160376548767092 },
    { lat: 47.93664438468553, lng: 13.175268173217775 },
    { lat: 47.94078439433587, lng: 13.177714347839355 },
    { lat: 47.94647636630159, lng: 13.18089008331299 },
    { lat: 47.94762618352869, lng: 13.185396194458008 },
    { lat: 47.95006946020493, lng: 13.203935623168945 },
    { lat: 47.95173657093309, lng: 13.221058845520021 },
    { lat: 47.95624899739721, lng: 13.226208686828615 },
    { lat: 47.9647554302679, lng: 13.235950469970703 },
    { lat: 47.97139292340828, lng: 13.246808052062988 },
    { lat: 47.97461079484555, lng: 13.25582027435303 },
    { lat: 47.973404116555436, lng: 13.26152801513672 },
    { lat: 47.96880698855037, lng: 13.271484375000002 },
    { lat: 47.961105882316616, lng: 13.287405967712404 },
    { lat: 47.958346997787274, lng: 13.298220634460451 },
    { lat: 47.959985103245444, lng: 13.303627967834474 },
    { lat: 47.96662320938706, lng: 13.307533264160156 },
    { lat: 47.96883572187128, lng: 13.30899238586426 },
    { lat: 47.97423730219761, lng: 13.315558433532715 },
    { lat: 47.98107466266583, lng: 13.318219184875488 },
    { lat: 47.983085478717804, lng: 13.321051597595215 },
    { lat: 47.9869919831294, lng: 13.333024978637697 },
    { lat: 47.991903418364146, lng: 13.344268798828127 },
    { lat: 47.991558771491746, lng: 13.349719047546388 },
    { lat: 47.9890600128292, lng: 13.352208137512209 },
    { lat: 47.98546963053961, lng: 13.35813045501709 },
    { lat: 47.978632852157574, lng: 13.372550010681154 },
    { lat: 47.979983044007554, lng: 13.37838649749756 },
    { lat: 47.98535473418224, lng: 13.383965492248537 },
    { lat: 47.98802600833743, lng: 13.393321037292482 },
    { lat: 47.98613027963109, lng: 13.399715423583986 },
    { lat: 47.98305675332569, lng: 13.403019905090332 },
    { lat: 47.97906376828657, lng: 13.415207862854006 },
    { lat: 47.98153428466898, lng: 13.426966667175293 },
    { lat: 47.98842812365697, lng: 13.45503330230713 },
    { lat: 47.994430758430006, lng: 13.461985588073732 },
    { lat: 47.99690053935378, lng: 13.486833572387697 },
    { lat: 48.00229918363818, lng: 13.495759963989258 },
    { lat: 48.01378378114427, lng: 13.498678207397461 },
    { lat: 48.02253906833847, lng: 13.499622344970705 },
    { lat: 48.026930504875615, lng: 13.507947921752931 },
    { lat: 48.01697030365482, lng: 13.567857742309572 },
    { lat: 48.010568351624975, lng: 13.583135604858398 },
    { lat: 48.004165604755016, lng: 13.616824150085451 },
    { lat: 48.01220480063063, lng: 13.655233383178713 },
    { lat: 48.006433933350344, lng: 13.67621898651123 },
    { lat: 48.00838633883708, lng: 13.688406944274904 },
    { lat: 48.00640522095352, lng: 13.705916404724123 },
    { name: 'Attnang-Puchheim', lat: 48.007222, lng: 13.713889 },
    { lat: 48.03964346940585, lng: 13.746643066406252 },
    { lat: 48.06592037437007, lng: 13.786468505859377 },
    { lat: 48.07876707848611, lng: 13.800544738769531 },
    { lat: 48.09000531373827, lng: 13.816165924072267 },
    { lat: 48.09459164290992, lng: 13.828268051147463 },
    { lat: 48.096082111817324, lng: 13.842601776123049 },
    { lat: 48.09453431631988, lng: 13.868350982666017 },
    { lat: 48.095394208459574, lng: 13.88603210449219 },
    { lat: 48.10141305078501, lng: 13.899936676025392 },
    { lat: 48.13355892629389, lng: 13.948516845703127 },
    { lat: 48.153375053814955, lng: 13.98387908935547 },
    { name: 'Wels Hbf', lat: 48.166667, lng: 14.033333 },
    { lat: 48.272225451004324, lng: 14.236907958984377 },
    { lat: 48.27353938358586, lng: 14.244976043701174 },
    { lat: 48.2746247806694, lng: 14.270896911621096 },
    { lat: 48.284163857836106, lng: 14.287548065185549 },
    { name: 'Linz Hbf', lat: 48.290278, lng: 14.290556 },
    { lat: 48.29438639992413, lng: 14.295358657836916 },
    { lat: 48.29649918414768, lng: 14.301795959472656 },
    { lat: 48.29118850614911, lng: 14.312095642089846 },
    { lat: 48.28496346003218, lng: 14.314413070678713 },
    { lat: 48.26039853733662, lng: 14.324884414672853 },
    { lat: 48.251883750871066, lng: 14.345226287841799 },
    { lat: 48.25125508626517, lng: 14.352607727050783 },
    { lat: 48.22673113793923, lng: 14.42856788635254 },
    { lat: 48.22072698210351, lng: 14.449253082275392 },
    { lat: 48.22135602193234, lng: 14.477577209472658 },
    { lat: 48.21592315033611, lng: 14.496374130249025 },
    { lat: 48.20808736236945, lng: 14.504957199096681 },
    { lat: 48.166486145079936, lng: 14.529161453247072 },
    { lat: 48.14020333595051, lng: 14.539375305175783 },
    { lat: 48.12909065009601, lng: 14.55842971801758 },
    { lat: 48.11768905589113, lng: 14.585552215576172 },
    { lat: 48.107373876206665, lng: 14.597997665405275 },
    { lat: 48.08088877008981, lng: 14.60838317871094 },
    { lat: 48.06792788330159, lng: 14.619712829589846 },
    { lat: 48.05725850962133, lng: 14.638681411743164 },
    { lat: 48.053357326351986, lng: 14.656620025634767 },
    { lat: 48.05198036756788, lng: 14.670953750610353 },
    { lat: 48.058807426879575, lng: 14.730262756347658 },
    { lat: 48.068845575590856, lng: 14.754896163940431 },
    { lat: 48.09023463991185, lng: 14.789056777954103 },
    { lat: 48.10301795640028, lng: 14.821414947509767 },
    { lat: 48.11786095800955, lng: 14.851369857788088 },
    { name: 'Amstetten', lat: 48.122222, lng: 14.872222 },
    { lat: 48.12118428591277, lng: 14.875059127807619 },
    { lat: 48.12628345723338, lng: 15.003032684326174 },
    { lat: 48.13453272975979, lng: 15.022773742675783 },
    { lat: 48.148851236206355, lng: 15.076503753662111 },
    { lat: 48.15509285476017, lng: 15.09324073791504 },
    { lat: 48.163394748618344, lng: 15.106801986694338 },
    { lat: 48.18766292375885, lng: 15.133495330810549 },
    { lat: 48.20065083439496, lng: 15.156154632568361 },
    { lat: 48.20700055257219, lng: 15.180530548095705 },
    { lat: 48.20911695037711, lng: 15.243530273437502 },
    { lat: 48.21329228954688, lng: 15.264215469360353 },
    { lat: 48.21964044055629, lng: 15.283699035644533 },
    { lat: 48.220441052353294, lng: 15.303611755371096 },
    { lat: 48.21912575493204, lng: 15.314598083496096 },
    { lat: 48.21495089144404, lng: 15.364551544189455 },
    { lat: 48.20831616149326, lng: 15.379829406738283 },
    { lat: 48.18800625890986, lng: 15.422658920288088 },
    { lat: 48.18772014644372, lng: 15.456218719482424 },
    { lat: 48.209288546366004, lng: 15.558271408081056 },
    { lat: 48.211118867805006, lng: 15.574064254760744 },
    { lat: 48.21689539076581, lng: 15.596208572387697 },
    { lat: 48.2159803414607, lng: 15.603933334350588 },
    { name: 'St. Pölten Hbf', lat: 48.204444, lng: 15.626389 },
    { lat: 48.20768696144312, lng: 15.647449493408205 },
    { lat: 48.21815355685701, lng: 15.681352615356447 },
    { lat: 48.23616481702338, lng: 15.71225166320801 },
    { lat: 48.24022362254108, lng: 15.768985748291017 },
    { lat: 48.25354110233028, lng: 15.80563545227051 },
    { lat: 48.26902616952623, lng: 15.838680267333986 },
    { lat: 48.272225451004324, lng: 15.864086151123049 },
    { lat: 48.275653030322324, lng: 15.89326858520508 },
    { lat: 48.29227352827105, lng: 15.920820236206056 },
    { lat: 48.296898890246894, lng: 15.934638977050783 },
    { lat: 48.295985271707664, lng: 15.977725982666017 },
    { lat: 48.29267326745168, lng: 16.05257034301758 },
    { lat: 48.286848187109086, lng: 16.078319549560547 },
    { lat: 48.21964044055629, lng: 16.18921279907227 },
    { lat: 48.21106167125026, lng: 16.215991973876957 },
    { lat: 48.20133732836298, lng: 16.245689392089847 },
    { lat: 48.19698937785695, lng: 16.263027191162113 },
    { lat: 48.19264105833093, lng: 16.29358291625977 },
    { lat: 48.1918400118522, lng: 16.319160461425785 },
    { name: 'Wien Westbahnhof', lat: 48.196389, lng: 16.337222 },
  ];

  return <TrainLineMap points={points} />;
};
